document.addEventListener("mousedown", (event) => {
  if (event.detail >= 2 && event.target instanceof Element && event.target.closest("summary")) {
    event.preventDefault();
  }
});
